import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import RequireAuth from '../RequireAuth';
import { V2Context } from './V2Context';
import { useV2Theme } from './useV2Theme';
import V2Shell from './V2Shell';
import CvePage from './pages/CvePage';
import DevicePage from './pages/DevicePage';
import DevicesPage from './pages/DevicesPage';
import DriftPage from './pages/DriftPage';
import GlobalPolicyPage from './pages/GlobalPolicyPage';
import PatchPage from './pages/PatchPage';
import PolicyPage from './pages/PolicyPage';
import V2SignIn from './V2SignIn';
import './v2.css';

// Everything under /v2: its own sign-in, layout and colours. The current site's navbar, theme and routes are not used here.
export default function V2App() {
  const [mode, toggleMode] = useV2Theme();
  return (
    <V2Context.Provider value={{ mode, toggleMode }}>
      <div className="v2" data-v2-theme={mode} data-testid="v2-root">
        <Routes>
          <Route path="/v2/signin" element={<V2SignIn />} />
          <Route element={<RequireAuth roles={[]} signInPath="/v2/signin"><V2Shell /></RequireAuth>}>
            <Route path="/v2" element={<Navigate to="/v2/devices" replace />} />
            <Route path="/v2/devices" element={<RequireAuth roles={['admin']} signInPath="/v2/signin"><DevicesPage /></RequireAuth>} />
            <Route path="/v2/devices/:deviceId" element={<RequireAuth roles={['admin']} signInPath="/v2/signin"><DevicePage /></RequireAuth>} />
            <Route path="/v2/patching" element={<RequireAuth roles={['admin']} signInPath="/v2/signin"><PatchPage /></RequireAuth>} />
            <Route path="/v2/software/policy" element={<RequireAuth roles={['admin']} signInPath="/v2/signin"><PolicyPage /></RequireAuth>} />
            <Route path="/v2/software/drift" element={<RequireAuth roles={['admin']} signInPath="/v2/signin"><DriftPage /></RequireAuth>} />
            <Route path="/v2/software/cve" element={<RequireAuth roles={['admin']} signInPath="/v2/signin"><CvePage /></RequireAuth>} />
            <Route path="/v2/global/policy" element={<RequireAuth roles={['admin']} signInPath="/v2/signin"><GlobalPolicyPage /></RequireAuth>} />
          </Route>
          <Route path="*" element={<Navigate to="/v2/devices" replace />} />
        </Routes>
      </div>
    </V2Context.Provider>
  );
}
